export const locales = ["RO", "EN"] as const;

// we require RO for now always
export type LocaleTranslationsObject = {
  [locale in (typeof locales)[number]]?: string;
};
